import { REDUCE_LIST_POLICIES } from '../../constants/actions/policies';

export function reduceListPolicies(payload) {
    return {
        type: REDUCE_LIST_POLICIES,
        payload,
    };
}
